module.exports = {
  appUrl: process.env.REACT_APP_URL,
  serverUrl: process.env.REACT_APP_SERVER_URL
}
